export default ({ COLORS }) => ({
  delete: {
    color: COLORS.RED.NORMAL
  }
})
